import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-drop-in',
	templateUrl: './icon-drop-in.component.svg',
})
export class IconDropInComponent {}
